import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../Providers/AuthProviders";
import { allEnrolledClasses } from "../../API/class";

function EnrolledClasses() {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    allEnrolledClasses(user?.email)
      .then((res) => res.json())
      .then((data) => setData(data));
  }, [user]);

  return (
    <>
      <p className="text-center font-bold text-5xl tracking-tight pt-10 font-serif dark:text-white">
        My Enrolled Classes
      </p>

      <div className="max-w-[85%] mx-auto mt-8 pb-16">
        <div className="relative overflow-x-auto sm:rounded-lg">
          {data.length > 0 ? (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-center text-gray-700 uppercase bg-green-100 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    No.
                  </th>
                  <th scope="col" className="py-3 text-left">
                    Image
                  </th>
                  <th scope="col" className="py-3 text-left">
                    Class Name
                  </th>
                  <th scope="col" className="py-3">
                    Instructor
                  </th>
                  <th scope="col" className="py-3">
                    Email
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((d, i) => (
                  <tr
                    key={d._id}
                    className="bg-white text-center border-b dark:bg-gray-700 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  >
                    <td className="w-4 p-4">
                      <div className="flex ps-2 items-center">{i + 1}</div>
                    </td>
                    <td>
                      <img className="w-16" src={d.classImage} alt="" />
                    </td>
                    <td className="py-4 font-medium text-gray-700 text-left whitespace-nowrap dark:text-white">
                      {d.className}
                    </td>
                    <td className="py-4">{d.instructor.name}</td>
                    <td className="py-4">{d.instructor.email}</td>
                    <td className="px-6 py-4">
                      <button
                        type="button"
                        className="text-green-500 font-medium text-center"
                      >
                        Enrolled!
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <h1 className="text-2xl lg:text-5xl py-20 font-bold text-center text-gray-400">No Classes Enrolled</h1>
          )}
        </div>
      </div>
    </>
  );
}

export default EnrolledClasses;
